import React, { useEffect, useState } from "react";
import { Space, Table, Input } from "antd";
import parser from "../../../../shared/helpers/parser";
import EditButton from "../../../../shared/components/editButton";
import DeleteButton from "../../../../shared/components/deleteButton";
import Utils from "../../../../shared/helpers/utils";
import EstablecimientosApi from "../../../establecimientos/api/EstablecimientosApi";
import ReferenciasApi from "../../../referencias/api/ReferenciasApi";
import AuthenticationHelper from "../../../../shared/helpers/authenticationHelper";

const AnexoIEmpresasTercerizadasTable = props => {
  const [establecimientosEmpresa, setEstablecimientosEmpresa] = useState([]);
  const [ciius, setCiius] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const permisosUsuario = AuthenticationHelper.getTipoUsuario() !== 'Operador';

  useEffect(() => {
    EstablecimientosApi.GetEmpresasByCuit(props.cuit).then((response) => { setEstablecimientosEmpresa(response); })
    ReferenciasApi.GetTabla("PUBLICACIONES.CIIU").then(response => { setCiius(response); });
  }, []);

  const filteredData = props.EmpresasTercerizadas.filter(item => {
    const establecimientoDesc = String(Utils.getIdDesc(item.IdEstablecimientoEmpresa, establecimientosEmpresa) || '');
    const ciiuDesc = String(Utils.getIdDesc(item.Ciiu, ciius) || '');
    const cuit = String(item.Cuit || '');
    return establecimientoDesc.toLowerCase().includes(searchValue.toLowerCase()) ||
           ciiuDesc.toLowerCase().includes(searchValue.toLowerCase()) ||
           cuit.toLowerCase().includes(searchValue.toLowerCase());
  });

  return (
    <>
      <Input
        placeholder="Buscar por establecimiento, CIIU o CUIT..."
        value={searchValue}
        onChange={e => setSearchValue(e.target.value)}
        style={{ marginBottom: 16, width: '100%' }}
      />
      <Table
      size="small"
      columns={[
        { title: 'Id', dataIndex: 'IdEmpresaTercerizada', key: 'IdEmpresaTercerizada' },
        { title: 'Id Establecimiento Empresa', dataIndex: 'IdEstablecimientoEmpresa', key: 'IdEstablecimientoEmpresa' },
        {
          title: 'Establecimiento Empresa', dataIndex: 'IdEstablecimientoEmpresa', key: 'IdEstablecimientoEmpresa',
          render: text => Utils.getIdDesc(text, establecimientosEmpresa)
        },
        { title: 'Cuit', dataIndex: 'Cuit', key: 'Cuit' },
        {
          title: 'Ciiu', dataIndex: 'Ciiu', key: 'Ciiu',
          render: text => Utils.getIdDesc(text, ciius)
        },
        { title: 'Cantidad Trabajadores', dataIndex: 'CantidadTrabajadores', key: 'CantidadTrabajadores' },
        //{ title: 'Fecha Insert', dataIndex: 'FechaInsert', key: 'FechaInsert', render: text => <span>{ parser.date(text) }</span> },
        props.formMode ? {
          title: '', dataIndex: 'Actions', key: 'Actions',
          render: (text, record) => {
            return <Space size="small">
              {
                permisosUsuario ?
                  <>
                    {
                      props.puedeEditar ?
                        <>
                          <EditButton onClick={() => props.onEdit(record)} />
                          <DeleteButton onConfirm={ () => props.onRemove(record) }/>
                          {/* {!record.IdEmpresaTercerizada ? <DeleteButton onConfirm={() => props.onRemove(record)} /> : ''} */}
                        </> : null
                    }
                  </> : null
              }
            </Space>
          }
        } : {},
      ]}
      dataSource={filteredData}
      rowKey={(record) => record.Id}
      pagination={{ hideOnSinglePage: true, pageSize: 10, showSizeChanger: false }}
    />
    </>
  );
}

export default AnexoIEmpresasTercerizadasTable;